import visibilityLoop from './visibility_loop'

// Calls `tick` once per animation frame on scroll and resize, but only while
// `el` is in the viewport: a scroll-driven section shouldn't keep measuring
// layout for the whole page once the visitor has scrolled past it. `tick` runs
// once when the section comes into view; `stop` (optional) runs when it leaves.
// Returns a teardown.
export default function scrollTick(el, { tick, stop }) {
  let frame = null
  const onScroll = () => {
    if (frame) return
    frame = requestAnimationFrame(() => {
      frame = null
      tick()
    })
  }

  return visibilityLoop(el, {
    start: () => {
      window.addEventListener('scroll', onScroll, { passive: true })
      window.addEventListener('resize', onScroll)
      tick()
    },
    stop: () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
      if (frame) cancelAnimationFrame(frame)
      frame = null
      if (stop) stop()
    }
  })
}
